var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49913 4.94507L7.55493 4.00087L1.3355 10.2203V11.1645H2.2797L8.49913 4.94507ZM9.44333 4.00087L10.3875 3.05667L9.44333 2.11247L8.49913 3.05667L9.44333 4.00087ZM2.8326 12.5H0V9.66673L8.97123 0.695508C9.09645 0.570324 9.26626 0.5 9.44333 0.5C9.62039 0.5 9.7902 0.570324 9.91543 0.695508L11.8045 2.58457C11.9297 2.7098 12 2.87961 12 3.05667C12 3.23374 11.9297 3.40355 11.8045 3.52877L2.83326 12.5H2.8326Z",
    fill: "#122945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6ab4fd1d7eb1a73506e16cf3689ff5a5.svg";
export { ForwardRef as ReactComponent };